<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Channels"
              bc1="App"
              bc2="Channels"
              bc3="List"
          ></Breadcrumb>
        </div>
        <div class="col-3">
          <div class="d-flex align-items-center justify-content-end">
            <button
                type="button"
                class="btn btn-gradient-danger btn-sm"
                @click="$router.back()"
            >
              <span class="text-nowrap">Back</span>
            </button>
          </div>
        </div>
      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-6">
                <div class="d-flex align-items-center">
                  <nav aria-label="breadcrumb">
                    <ol class="breadcrumb ">
                      <li class="breadcrumb-item"><a href="javascript:void(0)">Terminal</a></li>
                      <li class="breadcrumb-item" v-for="(crumb,index) in currentBreadCrumb">{{crumb}}</li>
                    </ol>
                  </nav>
                </div>
              </div>
              <div class="col-6">
                <div class="d-flex align-items-center justify-content-end">
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="routeToAddRecord"
                  >
                    <AddButtonText name="Channel" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <CommonTableStore
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :filteredData="filteredData"
              :externalTotalRecord="externalTotalRecord"
          />
        </div>
      </div>
    </div>
    <AssignPOSDeviceModal :show="showPosModal" :data="posModalData" @hide="showPosModal = false" />
    <TabbyConfigurationModal
      :show="showTabbyConfigModal"
      :row="selectedRowForTabbyConfig"
      type="channel"
      configurationType="channelConfigurations"
      modalSize="lg"
      modalTitle="Channel Service Configuration"
      @hide="showTabbyConfigModal = false"
      @completed="completedTabbyConfig"
    />
  </div>
  <!-- END: Content-->
</template>

<script>


import AssignPOSDeviceModal from "@/pages/dashboard/merchant/channels/AssignPOSDeviceModal.vue";
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";
import TabbyConfigurationModal from "@/pages/dashboard/merchant/channels/TabbyConfigurationModal.vue";

export default {
  components: {AddButtonText, AssignPOSDeviceModal, TabbyConfigurationModal},

  created() {},
  mounted() {
    localStorage.setItem("url",this.url);
    this.checkDataInStore(this.url)
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    var merchantChannel = this.$store.getters.getByKey(
        "merchantChannel"
    );
    this.terminalId = merchantChannel.row.id
    this.filteredData = {
      terminalId: this.terminalId,
      serviceConfiguration: 1
    }

    this.currentBreadCrumb.push(merchantChannel.row.name+'/'+merchantChannel.row.code)
  },
  data() {
    return {
      currentBreadCrumb:[],
      url: "v1/get-channel",
      storageKey: "merchantChannelList",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name",
          html: true
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function(value) {
            var html = "";
            if (value) {
              html = `<span class="text-primary">${value}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Type",
          valueKey: "type",
          html: true,
          alter: function(value, row) {
            let label = "";
            if(value){
              if (value.toString() == 1) {
                label = 'Eccomerce'
              }else if (value.toString() == 2) {
                label = 'POS'
              }else if (value.toString() == 3) {
                label = 'ATM'
              }
            }

            return `<span class="badge badge-light-primary badge-sm">${label}</span>`;
          }
        },
        {
          title: "POS Device",
          valueKey: "pos_devices",
          html: true,
          alter: (value) => {
            var html = "";
            if (value && value.length > 0) {
              html = `<span class="text-primary">${value[0].name}/${value[0].serial_number}</span>`;
              return html;
            } else {
              html = "-";
              return html;
            }
          }
        },
        {
          title: "Status",
          valueKey: "status",
          html: true,
          alter: function(value, row) {
            var html = "";
            if (value == true) {
              html = `<span class="badge badge-success badge-sm">Active</span>`;
            } else {
              html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
            }


            return html;
          }
        }
      ],
      actions: [
        {
          title: 'Configuration Settings',
          class: 'btn-primary badge',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "configurationSettings"
            };
            this.$store.dispatch("set", data);

            this.$router.push({ name: "configuration-settings",params: {channelId : row.id} });
          },

        },
        {
          title: "Services Configuration",
          class: 'badge btn-primary',
          cta: (row) => {
            this.selectedRowForTabbyConfig = row;
            this.showTabbyConfigModal = true;
          }
        },
        {
          title: "Update",
          class: "btn-primary badge ",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantChannelUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({ name: "update-channel",params: {terminalId : this.terminalId} });
          }
        },
        {
          title: 'Onboard Via Switch',
          class: 'badge btn-primary',
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "channelOnboardPFAC"
            };
            this.$store.dispatch("set", data);


            this.$router.push({ name: "channel-switch"});
          },

        },
        {
          title: "Assign POS Device",
          disableButtonRendering: true,
          conditionalRendering: true,
          condition: (row)=>{
            if(row.type.toString() == 2){
              return true
            }
            return false
          },
          disableCondition: (row)=>{
            if(row.type.toString() != 2){
              return true
            }
            return false
          },
          class: "btn-primary badge ml-50",
          cta: (row, index) => {
            let data = {
              ...row,
              index: index,
              row: row,
              key: "merchantChannelAssignPos",
              storageKey: this.storageKey,
              idx: index,
            }
            this.$store.dispatch("set", data);
            this.posModalData = data
            this.showPosModal = true

          }
        },

      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "merchantChannelDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: "",
      filteredData:{serviceConfiguration:1},
      showPosModal: false,
      posModalData: {},
      showTabbyConfigModal: false,
      selectedRowForTabbyConfig: null,
      force: false,
    };
  },
  methods: {
    routeToAddRecord(){
      this.$router.push({ name: "add-channel",params: {terminalId : this.terminalId}})

    },
    completedTabbyConfig() {
      this.$store.dispatch('renderPagination', !this.force);
      this.force = !this.force;
    },
    deleteRecord(data) {
      this.makeRequest("post", "v1/delete-channel", {
        status: data.row.status == true ? 1 : 0,
        channelId: data.row.id
      }).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          if (code == 200) {
            let storeData = this.$store.getters.getByKey(this.storageKey);
            if (storeData != null) {
              if (typeof storeData.firstPageData != "undefined") {
                if (
                    typeof storeData.firstPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.firstPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.firstPageData.data[data.index] = data.row;
                    delete storeData.otherPageData;
                  }
                }
              }
              if (typeof storeData.otherPageData != "undefined") {
                if (
                    typeof storeData.otherPageData.data[data.index] != "undefined"
                ) {
                  if (
                      storeData.otherPageData.data[data.index].id == data.row.id
                  ) {
                    storeData.otherPageData.data[data.index] = data.row;
                  }
                }
              }
              storeData.key = this.storageKey;
              this.$store.dispatch("set", storeData);
            }
          }
        }
      });
    }
  }
};
</script>
